<template>
    <div class="flex flex-wrap justify-start mb-2 gap-2">
        <div v-for="(room, index) in data"
            class="p-4 bg-gray-50 rounded-md border border-gray-300 w-full transition relative">
            <div @click="removeRoom(index)"
                class="w-5 h-5 absolute text-xs -right-2 -top-2 rounded-full bg-gray-100 text-gray-700 border border-gray-300 flex items-center justify-center hover:scale-90 transition cursor-pointer hover:bg-gray-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill=currentColor
                    viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                    <path
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                </svg>
            </div>
            <div class="w-full p-2">
                <search_select :id="$attrs.identifier+'['+ index +'][0]'" :options="JSON.parse($attrs.room_options)"
                    label="value" class="p-0 m-0 border-none border-0" :closeOnSelect=" true " :multiple=" false "
                    value_by="name"
                    >
                </search_select>
            </div>
            <div class="w-full p-2 flex flex-wrap gap-2">
                <add_setup_roomitem :data="room.slice(1)" :identifier="$attrs.identifier"
                    :options="JSON.parse($attrs.item_options)"
                    :room_idx="index">
                </add_setup_roomitem>
            </div>
        </div>

        <div @click="addRoom"
            class="p-4 bg-white rounded-md border border-gray-300 w-full flex justify-center items-center hover:scale-95 active:scale-90 hover:bg-gray-200 transition cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mr-2" fill=currentColor
                viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                <path
                    d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
            </svg>
            {{ $t('Add') }} {{ $attrs.name }}
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            data: JSON.parse(this.$attrs.data),
        };
    },
    methods: {
        addRoom(e) {
            this.data.push(Object.entries(JSON.parse(this.$attrs.room_options))[0]);
        },
        removeRoom(index) {
            var item = _.cloneDeep(this.data);
            item.splice(index, 1);
            this.data = [];

            var _this = this;
            setTimeout(function () {
                _this.data = item;
            }, 1)
        },
        ChangedValue(e, index) {
            console.log(e);
            this.data[index] = e[0];
        }
    }
};
</script>